import React from 'react';
import { IpaType } from '../../phonemes/ipa';
import { LanguageStats } from '../../world/trackLanguageFeatures';
import { Segments } from './Segments';

interface SummaryChartProps {
  readonly stats: LanguageStats;
  readonly onMouseOver?: (ipa: IpaType) => void;
}

/** show a summary of the various types of phonemes for a language */
export function SummaryChart(props: SummaryChartProps) {
  const { stats } = props;
  return (<table>
    <tbody>
      <tr>
        <th>not on chart</th>
        <td>{stats.otherIpa.length}</td>
        <Segments segments={stats.otherIpa} onMouseOver={props.onMouseOver} />
      </tr><tr>
        <th>vowels</th>
        <td>{stats.vowels.length}</td>
        <Segments segments={stats.vowels} onMouseOver={props.onMouseOver} />
      </tr><tr>
        <th>consonants</th>
        <td>{stats.consonants.length}</td>
        <Segments segments={stats.consonants} onMouseOver={props.onMouseOver} />
      </tr><tr>
        <th>clicks</th>
        <td>{stats.clicks.length}</td>
        <Segments segments={stats.clicks} onMouseOver={props.onMouseOver} />
      </tr><tr>
        <th>tones</th>
        <td>{stats.tones.length}</td>
        <Segments segments={stats.tones} onMouseOver={props.onMouseOver} />
      </tr><tr>
        <th>all segments</th>
        <td>{stats.segmentList.length}</td>
        <Segments segments={stats.segments.split(' ')} onMouseOver={props.onMouseOver} />
      </tr>
    </tbody>
  </table>);
}
